import type { UiKey } from './en';

export const pl: Record<UiKey, string> = {
  'lang.label': 'Język',

  'nav.residences': 'Rezydencje',
  'nav.mobility': 'Mobilność',
  'nav.retreats': 'Retreaty',
  'nav.slClub': 'SL Club',
  'nav.privateLine': 'Private Line',
  'nav.membership': 'Członkostwo',
  'nav.login': 'Zaloguj się',
  'nav.menu': 'Menu',
  'nav.closeMenu': 'Zamknij menu',
  'nav.home': 'Superluxury — strona główna',

  'menu.clientLine': 'Linia dla klientów',
  'menu.clientLineNote': 'Odbiera partner — o każdej porze.',

  'announcement.text': 'Prywatne konsultacje przyjmujemy teraz w naszych nowych atelier w Genewie i Dubaju.',
  'announcement.link': 'Poproś o prywatne spotkanie',
  'announcement.close': 'Zamknij komunikat',

  'hero.label': 'Przedstawiamy Superluxury',
  'hero.srTitle': 'Venturist — prywatny cykl wydarzeń Superluxury',
  'hero.tagline': 'Prywatny cykl Superluxury. Wyłącznie na zaproszenie.',
  'hero.discover': 'Odkryj Venturist',
  'hero.scroll': 'Przewiń dalej',
  'hero.pause': 'Wstrzymaj film',
  'hero.play': 'Odtwórz film',

  'footer.help': 'Czy możemy pomóc?',
  'footer.faq': 'Najczęstsze pytania',
  'footer.support': 'Wsparcie: angielski',
  'footer.house': 'Dom',
  'footer.locator': 'Znajdź atelier',
  'footer.locatorPlaceholder': 'KRAJ/REGION, MIASTO',
  'footer.findAtelier': 'Znajdź atelier',
  'footer.lettersTitle': 'Zapisz się na Listy Superluxury',
  'footer.lettersBody':
    'Otrzymuj ekskluzywne wiadomości o nowych usługach, osobiste zaproszenia i nowości ze świata Superluxury.',
  'footer.lettersThanks': 'Dziękujemy. Otrzymasz kolejny list.',
  'footer.email': 'E-mail',
  'footer.signUp': 'Zapisz się',
  'footer.emailError': 'Podaj prawidłowy adres e-mail.',
  'footer.country': 'Kraj/Region',
  'footer.services': 'Usługi Superluxury',
  'footer.discoverServices': 'Poznaj nasze usługi',
  'footer.seekIntro': 'Poproś o rekomendację',
  'footer.destinations': 'Destynacje',
  'footer.follow': 'Obserwuj nas',
  'footer.rights': 'Wszelkie prawa zastrzeżone.',
};
